import { cn } from '../../../lib/utils';

// A titled admin section. `id` anchors it for the sticky jump-nav. `actions`
// renders a right-aligned slot (typically a primary button) in the header.
const SectionCard = ({ id, title, description, actions, className, children }) => (
  <section
    id={id}
    className={cn(
      'scroll-mt-36 rounded-md border border-border/60 bg-background/40 p-5 sm:p-6',
      className
    )}
  >
    {(title || description || actions) && (
      <header className="mb-5 flex flex-col gap-3 border-b border-border/60 pb-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          {title && <h3 className="font-display text-lg font-semibold tracking-tight">{title}</h3>}
          {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </header>
    )}
    <div>{children}</div>
  </section>
);

export default SectionCard;
